import { IConsent } from 'Container/LeadManagementSystemForm/interface';
import { ConsentName } from 'Container/LeadManagementSystemForm/enum';

/** Get CMS config for futurizeLms repo from additionalPageOptions */
export const getCMSConfig = () => ({ ...window.additionalPageOptions?.futurizeLms });

/** Get consent config by name from additionalPageOptions */
export const getConsentConfig = (consentName: ConsentName): IConsent | undefined =>
    getCMSConfig()?.consent?.[consentName];

/** Get formErrors CMS config from additionalPageOptions */
export const getFormErrors = () => ({ ...window.brixPageOptions?.formErrors });
